import React from 'react'

import Select from 'Components/Select'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default class ComboMultiBool extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Title inline={this.props.inline} style={{padding: '5px 0'}} title={this.props.title} buttons={(this.props.comboMultipleOption(this.props.options)).length > 0 && !this.props.disabled &&
      <button type="button" onClick={this.props.onClickAddComboMultiBool}
              className="text-success ei-commun_ajouter"
              style={{display: 'inline-block', marginLeft: 5}}/>}>

        {
          (this.props.data !== undefined ? this.props.data : []).map((data, index) => (

            <Grid container style={{margin: 0, padding: 0}} spacing={0} justify={'center'}
                  alignItems={'center'}>
              <Grid item style={{margin: 0, padding: 0}}>
                <button type="button" onClick={() => this.props.onClickBoolComboMultiBool(index)}
                        disabled={this.props.disabled || false}
                        className={'ei-commun_pouce ei-' + (data.valeur_bool === true || data.valeur_bool === 1 || parseInt(data.valeur_bool) === 1 ? 'up primaryColor' : 'down secondaryColor')}/>
              </Grid>
              <Grid item xs style={{margin: 0, padding: 0}}>
                <Select style={this.props.style} options={this.props.comboMultipleOption(this.props.options, data.id)}
                        disabled={this.props.disabled || false}
                        name={index}
                        onChange={this.props.onChangeComboMultiBool}
                        value={data.id}/>
              </Grid>
              {!this.props.disabled && <Grid item style={{margin: 0, padding: 0}}>
                <button type="button" onClick={() => this.props.onClickRemoveComboMultiBool(index)}
                        className="text-danger ei-commun_enlever"
                        disabled={this.props.disabled || false}/>
              </Grid> }

            </Grid>
          ))
        }
      </Title>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/ComboMulti/ComboMultiBool.js